import { render, staticRenderFns } from "./SignInOidc.vue?vue&type=template&id=4b7acc42&"
import script from "./SignInOidc.vue?vue&type=script&lang=js&"
export * from "./SignInOidc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports